export default __webpack_public_path__ + "static/media/benefit_1.f355c8d5.png";